import React, { useContext, useState } from "react";
import AddMaterial from "./components/AddMaterial";
import MaterialList from "./components/MaterialList";
import NavPage from "../../../components/NavPage";
import { BoletimContext } from "../../../context/BoletimContext";
import CabecalhoBoletim from "../../Boletim/components/CabecalhoBoletim";

import "./styles/estilo-dark.css";

function ItensApreendidos() {
  const { boletim, setBoletim } = useContext(BoletimContext);
  const [editingIndex, setEditingIndex] = useState(null);

  return (
    <div className="bo-form-root">
      <CabecalhoBoletim texto="Materiais Apreendidos" />

      <AddMaterial
        boletim={boletim}
        setBoletim={setBoletim}
        editingIndex={editingIndex}
        onEditIndex={setEditingIndex}
      />

      <MaterialList
        boletim={boletim}
        setBoletim={setBoletim}
        editingIndex={editingIndex}
        onEditIndex={setEditingIndex}
        onEdit={(index) => setEditingIndex(index)}
      />

      <NavPage prev="../envolvido" next="../efetivo" />
    </div>
  );
}

export default ItensApreendidos;
